/* ===========================================================================
   Peach Up — LP da loja internacional oficial dentro da MKPBR
   Vitrine, ficha do produto, carrinho proprio, seletores e faixa de mercado.

   DEGRAUS DO DESCONTO: 2 itens = 5%, 3 = 10%, 4+ = 15%, contando o TOTAL DE
   ITENS DO CARRINHO (soma produtos diferentes). Quem APLICA e o app Pumper,
   no servidor — esta pagina so mostra. Os degraus vem do #pu-cfg, e a fonte
   da verdade e a configuracao do Pumper, que o storefront nao consegue ler.
   =========================================================================== */
(function () {
  'use strict';

  var D = document;
  var $ = function (s, r) { return (r || D).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); };

  /* ---------- dados ------------------------------------------------------ */
  function readJSON(id, fallback) {
    var el = D.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { console.error('[peachup] JSON invalido em #' + id, e); return fallback; }
  }
  var CFG = readJSON('pu-cfg', {});
  var RAW = readJSON('pu-data', []);

  /* O Liquid devolve numero como texto em varios campos. Converte UMA vez,
     logo depois de ler o JSON, para nao quebrar em .toFixed() la na frente. */
  var PRODUCTS = RAW.filter(function (p) { return p && p.vid; }).map(function (p) {
    p.pr = Number(p.pr) || 0;
    p.prf = String(p.prf == null ? '' : p.prf);
    p.cmpf = p.cmpf ? String(p.cmpf) : null;
    p.cmp = p.cmp == null ? null : Number(p.cmp);
    p.av = p.av === true || p.av === 'true';
    p.img = Array.isArray(p.img) ? p.img : [];
    p.tags = Array.isArray(p.tags) ? p.tags : [];
    return p;
  });

  /* ---------- idiomas ---------------------------------------------------- */
  var DICT = (window.PU_I18N || {});
  var ISO = (CFG.iso || D.documentElement.lang || 'en');
  var PACK = DICT[ISO] || DICT[ISO.split('-')[0]] || DICT.en || {};
  var EN = DICT.en || {};
  function t(k) { return PACK[k] || EN[k] || ''; }

  function paint(root) {
    $$('[data-i18n]', root || D).forEach(function (el) {
      var v = t(el.getAttribute('data-i18n'));
      if (v) el.textContent = v;
    });
    /* rotulos de acessibilidade que precisam de texto e nao de conteudo */
    $$('[data-i18n-aria]', root || D).forEach(function (el) {
      var v = t(el.getAttribute('data-i18n-aria'));
      if (v) el.setAttribute('aria-label', v);
    });
  }

  /* ---------- dinheiro --------------------------------------------------- */
  var CURRENCY = 'USD';
  /* Usado SO no carrinho: ali o /cart.js entrega a moeda do mercado.
     Nos cards e na ficha usamos p.prf, que o Liquid ja formatou — foi assim
     que o preco japones aparecia como "$8,900.00" em vez de iene: o Intl caia
     no dolar quando o carrinho ainda estava vazio. */
  function money(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(ISO, { style: 'currency', currency: CURRENCY }).format(n);
    } catch (e) {
      return CURRENCY + ' ' + n.toFixed(2);
    }
  }

  /* ---------- familias --------------------------------------------------- */
  /* Um produto pode aparecer em MAIS DE UMA prateleira, e isso e de
     proposito. O Trio Kit leva BoomBoom Up, Sugar Up e Fit Up, entao ele
     aparece nas tres. Quem chega querendo BoomBoom ve de uma vez todas as
     formas de levar BoomBoom: o pote sozinho, os multipacks e os kits que o
     incluem.

     Antes existia uma prateleira separada so de kits, e o resultado era
     tres prateleiras com UM card cada e o resto da linha vazio, porque a
     MKPBR vende um pote por linha e sete kits. */
  function fams(p) {
    var h = String(p.h || '').toLowerCase();
    var saida = [];
    if (h.indexOf('boomboom') > -1) saida.push('bb');
    if (h.indexOf('fit-up') > -1) saida.push('fu');
    if (h.indexOf('sugar-up') > -1) saida.push('sg');
    if (saida.length) return saida;
    /* Sem pista no handle, cai nas tags. Vale para produto novo que a MKPBR
       ative depois e que nao siga o padrao de nome das linhas atuais. */
    var tags = p.tags.map(function (x) { return String(x).toLowerCase(); });
    if (tags.indexOf('body gel') > -1 || tags.indexOf('body scrub') > -1) saida.push('sg');
    if (tags.indexOf('body cream') > -1) saida.push('bb');
    return saida.length ? saida : ['bb'];
  }

  /* O pote sozinho da linha abre a propria prateleira: e ele que a pessoa
     veio ver. Kits e multipacks vem depois, na ordem de relevancia. */
  function ehOPote(p) {
    var h = String(p.h || '').toLowerCase();
    return fams(p).length === 1 && h.indexOf('kit') < 0 && h.indexOf('-pack') < 0;
  }
  /* ---------- relevancia -------------------------------------------------- */
  /* Ordem da vitrine "os mais vendidos" da Home da marca, lida do site em
     13/09/2026: BoomBoom Up, Duplinha BoomBoom+Fit Up, Trio, Fit Up,
     Sugar Up, e depois os multipacks. O BoomBoom Up abre a lista la (leva o
     selo de MAIS VENDIDO) e abre aqui tambem.

     O Bumbum Lisinho entra junto dos kits curados: a marca nao o lista
     porque e montagem da MKPBR, mas e da mesma familia de kit fechado que a
     Duplinha e o Trio, e nao de multipack do mesmo pote. */
  var RELEVANCIA = [
    'peach-up-boomboom-up-firming-body-cream-200g',
    'peach-up-duo-kit-boomboom-up-fit-up',
    'peach-up-trio-kit-boomboom-up-sugar-up-fit-up',
    'peach-up-bumbum-lisinho-kit-boomboom-up-sugar-up',
    'peach-up-fit-up-body-contour-cream-200g',
    'peach-up-sugar-up-exfoliating-body-gel-200g',
    'peach-up-boomboom-up-2-pack-200g'
  ];

  function relevancia(p) {
    var i = RELEVANCIA.indexOf(p.h);
    if (i > -1) return i;
    /* Produto que a marca nao lista (ou que a MKPBR ative depois): ordena
       pela linha, na mesma hierarquia do site — BoomBoom, Fit Up, Sugar Up. */
    var h = String(p.h || '').toLowerCase();
    var linha = h.indexOf('boomboom') > -1 ? 0 : (h.indexOf('fit-up') > -1 ? 1 : 2);
    return RELEVANCIA.length + linha * 100;
  }

  /* Produtos SEM ESTOQUE vao para o fim de cada prateleira. Dentro do
     estoque: primeiro o pote da linha, depois a relevancia da vitrine da
     marca, e o preco so desempata. */
  function ordena(a, b) {
    if (a.av !== b.av) return a.av ? -1 : 1;
    var pa = ehOPote(a) ? 0 : 1, pb = ehOPote(b) ? 0 : 1;
    if (pa !== pb) return pa - pb;
    var ra = relevancia(a), rb = relevancia(b);
    if (ra !== rb) return ra - rb;
    return a.pr - b.pr;
  }

  /* ---------- vitrine ---------------------------------------------------- */
  function cardHTML(p) {
    var img = p.img[0] || {};
    var preco = p.cmpf ? '<s>' + esc(p.cmpf) + '</s>' + esc(p.prf) : esc(p.prf);
    return '' +
      '<div class="pu-card__img">' +
        '<img src="' + esc(img.s || '') + '" alt="' + esc(img.a || p.t) + '" loading="lazy" width="900" height="900">' +
        '<span class="pu-card__quick">' + esc(t('quick')) + '</span>' +
        (p.av ? '' : '<span class="pu-card__flag">' + esc(t('soldout')) + '</span>') +
      '</div>' +
      '<div class="pu-card__body">' +
        '<h3>' + esc(p.t) + '</h3>' +
        '<div class="pu-card__price">' + preco + '</div>' +
        '<button type="button" class="pu-btn pu-btn--sm pu-btn--full pu-card__add" data-pu-add="' + p.vid + '"' +
          (p.av ? '' : ' disabled') + '>' +
          esc(p.av ? t('add') : t('soldout')) +
        '</button>' +
      '</div>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderGrids() {
    var buckets = { bb: [], fu: [], sg: [] };
    PRODUCTS.forEach(function (p) {
      fams(p).forEach(function (k) { if (buckets[k]) buckets[k].push(p); });
    });
    Object.keys(buckets).forEach(function (k) {
      var grid = $('[data-pu-grid="' + k + '"]');
      if (!grid) return;
      var list = buckets[k].sort(ordena);
      if (!list.length) {
        var sec = grid.parentElement;
        if (sec) sec.hidden = true;
        /* Sem produto na familia, o atalho la de cima tambem sai: um chip
           que rola para uma secao escondida nao leva a lugar nenhum. */
        $$('.pu-fam[href="#' + (sec ? sec.id : '') + '"]').forEach(function (a) {
          a.hidden = true;
        });
        return;
      }
      grid.innerHTML = '';
      grid.setAttribute('aria-busy', 'false');
      list.forEach(function (p) {
        /* O card NAO pode ser um <button>: botao dentro de botao e HTML
           invalido. Uma div com role=button e tabindex=0 resolve, e o clique
           no botao de comprar e tratado ANTES do clique no card. */
        var el = D.createElement('div');
        el.className = 'pu-card' + (p.av ? '' : ' pu-card--out');
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.setAttribute('aria-label', p.t);
        el.dataset.puHandle = p.h;
        el.innerHTML = cardHTML(p);
        grid.appendChild(el);
      });
    });
  }

  /* ---------- trava de rolagem ------------------------------------------- */
  /* Precisa travar o HTML, nao so o body: como o html tem overflow-x:clip,
     ele deixou de ser 'visible' e virou o elemento que rola. Travando so o
     body, a roda do mouse continuava rolando a LP por tras do popup. */
  var travas = 0;
  function travarRolagem() {
    travas++;
    D.documentElement.classList.add('pu-lock');
    D.body.classList.add('pu-lock');
  }
  function destravarRolagem(tudo) {
    travas = tudo ? 0 : Math.max(0, travas - 1);
    if (travas === 0) {
      D.documentElement.classList.remove('pu-lock');
      D.body.classList.remove('pu-lock');
    }
  }

  /* ---------- ficha do produto ------------------------------------------- */
  var pdpOvl, pdpBox, lastFocus = null;

  function bulletsHTML(txt) {
    if (!txt) return '';
    var linhas = String(txt).split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
    if (linhas.length > 1) {
      return '<ul>' + linhas.map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('') + '</ul>';
    }
    return '<p>' + esc(linhas[0] || '') + '</p>';
  }
  function parasHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n{2,}|\n---\n/).map(function (b) {
      var l = b.trim(); if (!l) return '';
      return '<p>' + esc(l).replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }
  /* "Ingredientes explicados" vem em blocos separados por ---, e cada bloco
     comeca com o NOME do ingrediente na primeira linha. Sem hierarquia, nome e
     explicacao encostam um no outro e o bloco vira parede de texto. */
  function ingHTML(txt) {
    if (!txt) return '';
    return String(txt).split(/\n?---\n?/).map(function (bloco) {
      var linhas = bloco.split('\n').map(function (l) { return l.trim(); }).filter(Boolean);
      if (!linhas.length) return '';
      var nome = linhas.shift();
      return '<p><strong>' + esc(nome) + '</strong>' +
             (linhas.length ? '<br>' + linhas.map(esc).join('<br>') : '') + '</p>';
    }).join('');
  }

  function acc(key, body, open) {
    if (!body) return '';
    return '<details class="pu-acc"' + (open ? ' open' : '') + '>' +
      '<summary>' + esc(t(key)) + '</summary>' +
      '<div class="pu-acc__c">' + body + '</div></details>';
  }

  /* Card de desconto por quantidade DENTRO da ficha do produto. E o lugar onde
     a pessoa decide levar mais de um — mostrar o degrau so la embaixo na pagina
     nao ajuda quem esta com o popup aberto. Quem APLICA continua sendo o
     Pumper, no servidor; aqui e vitrine. */
  function qdHTML() {
    var passos = CFG.steps || [];
    if (!passos.length) return '';
    return '<div class="pu-pdp__qd" data-pu-pdp-qd>' +
      '<strong>' + esc(t('qd_t')) + '</strong>' +
      '<ul>' + passos.map(function (s) {
        var rot = s.q >= 4 ? t('qd_4') : t('qd_' + s.q);
        return '<li data-q="' + s.q + '"><b>' + s.p + '%</b><span>' + esc(rot) + '</span></li>';
      }).join('') + '</ul>' +
      '<small>' + esc(t('qd_d')) + ' ' + esc(t('qd_note')) + '</small>' +
    '</div>';
  }
  /* ---------- quantidade dentro da ficha ---------------------------------- */
  var PDP_QTD_MAX = 10;

  function qtdHTML() {
    return '<div class="pu-pdp__qty">' +
      '<span class="pu-pdp__qty-l" id="pu-pdp-qty-l">' + esc(t('pdp_qty')) + '</span>' +
      '<span class="pu-step pu-step--lg" role="group" aria-labelledby="pu-pdp-qty-l">' +
        '<button type="button" data-pu-pdp-step="-1" aria-label="' + esc(t('c_less')) + '" disabled>&minus;</button>' +
        '<span data-pu-pdp-qtd aria-live="polite">1</span>' +
        '<button type="button" data-pu-pdp-step="1" aria-label="' + esc(t('c_more')) + '">+</button>' +
      '</span>' +
    '</div>';
  }

  /* Programa de entrega garantida da MKPBR, dentro da ficha. E aqui que a
     pessoa decide comprar, e a duvida que trava a compra internacional e
     sempre a mesma: "vou pagar taxa quando chegar?". A resposta tem de estar
     ao lado do botao, nao so numa secao la embaixo.
     A excecao ("o que nao cobre") vem junto: garantia que so mostra o lado
     bom vira contestacao de cartao depois. */
  /* Mesmo selo do bloco da MKPBR, em SVG: herda a cor verde daqui sem
     precisar de uma segunda arte. */
  var SELO = '<svg class="pu-selo pu-selo--sm" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.6 4.6 5.4v6c0 4.4 3.1 8.5 7.4 9.9 4.3-1.4 7.4-5.5 7.4-9.9v-6L12 2.6Z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 12.1l2.3 2.3 4.5-4.6" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  function entregaHTML() {
    return '<div class="pu-pdp__del">' +
      '<strong>' + SELO + '<span>' + esc(t('del_t')) + '</span></strong>' +
      '<p>' + esc(t('del_pdp')) + '</p>' +
      '<a href="' + esc(CFG.delUrl || '#') + '" target="_blank" rel="noopener">' +
        esc(t('del_full')) +
      '</a>' +
    '</div>';
  }

  function pdpQtd() {
    var el = $('[data-pu-pdp-qtd]');
    var n = el ? parseInt(el.textContent, 10) : 1;
    return (isFinite(n) && n > 0) ? Math.min(PDP_QTD_MAX, n) : 1;
  }

  function porQtdPDP(n) {
    var el = $('[data-pu-pdp-qtd]');
    if (!el) return;
    n = Math.min(PDP_QTD_MAX, Math.max(1, n));
    el.textContent = String(n);
    var menos = $('[data-pu-pdp-step="-1"]');
    var mais = $('[data-pu-pdp-step="1"]');
    if (menos) menos.disabled = n <= 1;
    if (mais) mais.disabled = n >= PDP_QTD_MAX;
    marcarDegrausPDP();
  }

  function marcarDegrausPDP() {
    var caixa = $('[data-pu-pdp-qd]');
    if (!caixa) return;
    /* O desconto do Pumper conta o carrinho INTEIRO, nao este produto. Entao
       o degrau que acende e o do que o carrinho VAI TER depois de somar a
       quantidade escolhida aqui: e isso que a pessoa vai pagar. */
    var total = CART.count + pdpQtd();
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (total >= s.q) atingido = s; });
    $$('li', caixa).forEach(function (li) {
      li.classList.toggle('is-on', !!atingido && Number(li.dataset.q) === atingido.q);
    });
  }

  function openPDP(handle) {
    var p = PRODUCTS.filter(function (x) { return x.h === handle; })[0];
    if (!p || !pdpOvl) return;
    lastFocus = D.activeElement;

    var preco = p.cmpf ? '<s>' + esc(p.cmpf) + '</s>' + esc(p.prf) : esc(p.prf);
    var thumbs = p.img.map(function (im, i) {
      return '<button type="button" data-pu-th="' + i + '"' + (i === 0 ? ' aria-current="true"' : '') +
        '><img src="' + esc(im.s) + '" alt="" loading="lazy"></button>';
    }).join('');

    pdpBox.innerHTML = '' +
      '<button type="button" class="pu-x" data-pu-pdp-close aria-label="' + esc(t('pdp_close')) + '">&times;</button>' +
      '<div class="pu-pdp">' +
        '<div class="pu-pdp__gal">' +
          '<div class="pu-pdp__main"><img src="' + esc((p.img[0] || {}).s || '') + '" alt="' + esc((p.img[0] || {}).a || p.t) + '" data-pu-main></div>' +
          (p.img.length > 1 ? '<div class="pu-pdp__thumbs">' + thumbs + '</div>' : '') +
        '</div>' +
        '<div class="pu-pdp__info">' +
          '<h2 id="pu-pdp-t">' + esc(p.t) + '</h2>' +
          (p.ai && p.ai.tag
            ? '<p style="margin:0"><span class="pu-eyebrow" style="display:block;margin:0 0 .2rem">' + esc(t('pdp_tagline')) + '</span>' +
              '<span style="color:var(--pu-suave)">' + esc(p.ai.tag) + '</span></p>'
            : '') +
          '<div class="pu-pdp__price">' + preco + '</div>' +
          /* Ordem de proposito: primeiro a pessoa escolhe quantas leva, e o
             degrau de desconto logo abaixo acende sozinho. Se o seletor
             ficasse depois da tabela, mudar a quantidade acenderia algo
             acima do controle e ninguem veria. */
          (p.av ? qtdHTML() : '') +
          qdHTML() +
          '<div class="pu-pdp__acts">' +
            '<button type="button" class="pu-btn pu-btn--ghost" data-pu-add="' + p.vid + '"' + (p.av ? '' : ' disabled') + '>' +
              esc(p.av ? t('add') : t('soldout')) + '</button>' +
            '<button type="button" class="pu-btn" data-pu-buy="' + p.vid + '"' + (p.av ? '' : ' disabled') + '>' +
              esc(t('buy')) + '</button>' +
          '</div>' +
          entregaHTML() +
          '<div style="margin-top:.4rem">' +
            acc('pdp_purpose', bulletsHTML(p.ai && p.ai.pur), true) +
            acc('pdp_high', bulletsHTML(p.ai && p.ai.hig)) +
            acc('pdp_how', parasHTML(p.ai && p.ai.how)) +
            acc('pdp_audience', parasHTML(p.ai && p.ai.aud)) +
            acc('pdp_good', bulletsHTML(p.ai && p.ai.gtk)) +
            acc('pdp_ing', ingHTML(p.ai && p.ai.ing)) +
            acc('pdp_tog', parasHTML(p.ai && p.ai.tog)) +
            acc('pdp_desc', parasHTML(p.d)) +
          '</div>' +
          (p.sku ? '<p class="pu-nota" style="margin:0">' + esc(t('pdp_sku')) + ': ' + esc(p.sku) + '</p>' : '') +
        '</div>' +
      '</div>';

    pdpOvl.classList.add('is-on');
    travarRolagem();
    marcarDegrausPDP();
    var x = $('[data-pu-pdp-close]', pdpBox);
    if (x) x.focus();
  }

  function closePDP() {
    if (!pdpOvl || !pdpOvl.classList.contains('is-on')) return;
    pdpOvl.classList.remove('is-on');
    destravarRolagem();
    pdpBox.innerHTML = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- carrinho ---------------------------------------------------- */
  var CART = { items: [], total: 0, count: 0 };
  var cartEl, veilEl, bodyEl, footEl, totalEl, countEl, qdEl, shipEl;

  /* ---------- barra de frete da loja x carrinho da LP ---------------------
     A dock de frete da loja (#mkpbrDock) e position:fixed com z-index
     2147482000 — perto do maximo do inteiro. Nenhuma camada da LP passa por
     cima disso sem entrar numa corrida de z-index que nao vale a pena e que
     a gente nao deveria disputar com um componente da loja.

     No celular, com o carrinho aberto, ela cobria o botao de pagar INTEIRO:
     medido em 14/09/2026, a dock ocupava de 740 a 824 e o botao de 743 a 791
     num visor de 812. Ninguem conseguia pagar sem fechar o carrinho.

     A solucao tem duas metades:
       1. o CSS tira a dock de cena enquanto qualquer sobreposicao da LP
          estiver aberta (a classe pu-lock ja marca exatamente esse estado, e
          vale tambem para a ficha do produto, que tinha o mesmo problema);
       2. esta funcao escreve o recado de frete DENTRO do carrinho, logo
          acima do botao. Assim nada se sobrepoe e o que faz a pessoa somar
          mais um item — o quanto ela economiza — nao se perde.

     A linha e CALCULADA, nao copiada do texto da dock. Duas razoes, e as
     duas apareceram na pratica em 14/09/2026:

     1. COPIAR ATRASAVA UM PASSO. A dock se redesenha sozinha, no tempo dela,
        depois que o carrinho muda. Lendo o texto dela dentro do syncCart —
        que roda logo apos o /cart.js — a gente pegava o estado ANTERIOR.
        Quem subia para 4 unidades e voltava para 3 continuava vendo "portes
        gratis desbloqueados". A dock estava certa; o espelho e que lia cedo
        demais. Calculando a partir do MESMO carrinho que acabou de chegar,
        nao existe corrida: o numero nasce junto com o total.

     2. O TEXTO DA DOCK FALA EM DEGRAU E ESCADA. Isso e linguagem de quem
        montou a regra, nao de quem esta comprando. Aqui a frase diz o que a
        pessoa ganha se agir: quanto somar e quanto cai no frete.

     MKPBR_SHIP.compute(carrinho) devolve, ja na moeda do mercado:
       faltaProximo    quanto falta em produtos para o proximo degrau
       economiaProximo quanto o frete cai quando chegar la
       freeReached     se o frete gratis ja foi atingido
     Valores em unidade inteira (53.41 = US$ 53,41), por isso o x100 antes de
     passar pelo money().

     Defensivo: sem a API, sem carrinho, ou sem proximo degrau (ha paises que
     nao tem frete gratis na tabela), a linha some. Melhor nao dizer nada do
     que dizer algo errado sobre frete. */
  function espelharFrete() {
    if (!shipEl) return;
    var S = window.MKPBR_SHIP;
    if (!S || typeof S.compute !== 'function' || !CART.raw || CART.count < 1) {
      shipEl.hidden = true;
      return;
    }

    var e;
    try { e = S.compute(CART.raw); } catch (err) {
      console.error('[peachup] frete', err);
      shipEl.hidden = true;
      return;
    }
    if (!e) { shipEl.hidden = true; return; }

    if (e.freeReached) {
      shipEl.innerHTML = '<b>' + esc(t('ship_free')) + '</b>';
    } else if (e.faltaProximo > 0 && e.economiaProximo > 0) {
      var texto = t('ship_more')
        .replace('{v}', money(Math.round(e.faltaProximo * 100)))
        .replace('{p}', money(Math.round(e.economiaProximo * 100)));
      shipEl.innerHTML = '<b>' + esc(texto) + '</b>';
    } else {
      shipEl.hidden = true;
      return;
    }
    shipEl.hidden = false;
  }

  function cartURL(path) {
    var root = CFG.root || '';
    return root + path;
  }

  /* UM lugar so para absorver um carrinho do Shopify. Antes, fetchCart e
     changeQty copiavam os campos cada um por conta propria; quando o calculo
     do frete passou a precisar do payload CRU, so o fetchCart foi atualizado.
     Resultado: mexer na quantidade dentro do carrinho nao mudava a linha de
     frete, porque CART.raw continuava sendo o do primeiro carregamento.
     Com os dois passando por aqui, nao ha como um esquecer o que o outro faz. */
  function aplicarCarrinho(c) {
    if (!c) return;
    CART.items = c.items || [];
    CART.total = c.total_price || 0;
    CART.count = c.item_count || 0;
    CART.raw = c;
    if (c.currency) CURRENCY = c.currency;
    syncCart();
  }

  function fetchCart() {
    return fetch(cartURL('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        aplicarCarrinho(c);
        return c;
      })
      .catch(function (e) { console.error('[peachup] cart.js', e); });
  }

  function syncCart() {
    if (countEl) countEl.textContent = CART.count;
    /* A barra de frete do rodape so deve aparecer DEPOIS que existe carrinho:
       com carrinho vazio ela anunciaria um degrau para quem ainda nao escolheu
       nada. O CSS esconde o dock enquanto o body nao tem esta classe. */
    D.body.classList.toggle('pu-has-cart', CART.count > 0);
    renderCart();
    markStep();
  }

  function renderCart() {
    if (!bodyEl) return;
    if (!CART.items.length) {
      bodyEl.innerHTML =
        '<div class="pu-cart__empty">' +
          '<strong>' + esc(t('c_empty')) + '</strong>' +
          '<span>' + esc(t('c_empty_d')) + '</span>' +
          '<button type="button" class="pu-btn pu-btn--ghost pu-btn--sm" data-pu-cart-close>' + esc(t('c_empty_cta')) + '</button>' +
        '</div>';
      if (footEl) footEl.hidden = true;
      return;
    }
    bodyEl.innerHTML = CART.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<div class="pu-line" data-key="' + esc(it.key) + '">' +
        '<div class="pu-line__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="pu-line__b">' +
          '<span class="pu-line__t">' + esc(it.product_title || it.title) + '</span>' +
          '<div class="pu-line__r">' +
            '<span class="pu-step">' +
              '<button type="button" data-pu-qty="-1" aria-label="' + esc(t('c_less')) + '">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-pu-qty="1" aria-label="' + esc(t('c_more')) + '">+</button>' +
            '</span>' +
            '<span class="pu-line__p">' + money(it.final_line_price != null ? it.final_line_price : it.line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="pu-line__x" data-pu-rm>' + esc(t('c_rm')) + '</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (footEl) footEl.hidden = false;
    if (totalEl) totalEl.textContent = money(CART.total);
  }

  function markStep() {
    var atingido = null;
    (CFG.steps || []).forEach(function (s) { if (CART.count >= s.q) atingido = s; });

    $$('[data-pu-qd] .pu-qd__step').forEach(function (el) {
      el.classList.toggle('pu-qd__step--on', !!atingido && Number(el.dataset.q) === atingido.q);
    });

    /* Linha do degrau dentro do carrinho. Quem aplica e o Pumper, no servidor:
       aqui so avisamos que o desconto JA vale, para o cliente nao pensar que
       precisa de cupom. */
    marcarDegrausPDP();

    if (qdEl) {
      if (atingido) {
        var rotulo = atingido.q >= 4 ? t('qd_4') : t('qd_' + atingido.q);
        qdEl.textContent = rotulo + ' · ' + atingido.p + '% ' + t('qd_off') + ' — ' + t('qd_note');
        qdEl.hidden = false;
      } else {
        qdEl.hidden = true;
      }
    }

    espelharFrete();
  }

  function openCart() {
    if (!cartEl || cartEl.classList.contains('is-on')) return;
    cartEl.classList.add('is-on');
    cartEl.setAttribute('aria-hidden', 'false');
    if (veilEl) { veilEl.hidden = false; requestAnimationFrame(function () { veilEl.classList.add('is-on'); }); }
    travarRolagem();
    /* De novo na abertura: a dock e desenhada pela loja e pode ter terminado
       de calcular depois do ultimo syncCart. */
    espelharFrete();
    var c = $('[data-pu-cart-close]', cartEl);
    if (c) c.focus();
  }
  function closeCart() {
    if (!cartEl || !cartEl.classList.contains('is-on')) return;
    cartEl.classList.remove('is-on');
    cartEl.setAttribute('aria-hidden', 'true');
    if (veilEl) { veilEl.classList.remove('is-on'); setTimeout(function () { veilEl.hidden = true; }, 220); }
    destravarRolagem();
  }

  var toastT;
  function toast(msg) {
    var el = $('[data-pu-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  function addToCart(vid, abrir, btn, qtd) {
    var q = Math.min(PDP_QTD_MAX, Math.max(1, Number(qtd) || 1));
    var rotuloOriginal = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = t('adding'); }
    return fetch(cartURL('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: q }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        if (btn) { btn.disabled = false; btn.textContent = t('added'); setTimeout(function () { btn.textContent = rotuloOriginal; }, 1400); }
        /* Volta o seletor para 1: se a ficha continua aberta, a proxima
           adicao nao pode levar a quantidade da anterior sem querer. */
        porQtdPDP(1);
        /* Adicionar pelo card ou pelo "adicionar ao carrinho" NAO abre o
           carrinho — so atualiza o contador. O "comprar agora" abre, porque
           ali a intencao e fechar. */
        if (abrir) openCart(); else toast(t('toast_added'));
      })
      .catch(function (e) {
        console.error('[peachup] add', e);
        if (btn) { btn.disabled = false; btn.textContent = rotuloOriginal; }
        toast(t('err_add'));
      });
  }

  function changeQty(key, qty) {
    return fetch(cartURL('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { aplicarCarrinho(c); })
      .catch(function (e) { console.error('[peachup] change', e); });
  }

  /* ---------- seletores de pais e idioma ---------------------------------- */
  function bindPicker(wrap) {
    if (!wrap) return;
    var btn = $('.pu-pick__btn', wrap);
    var menu = $('.pu-pick__menu', wrap);
    if (!btn || !menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var aberto = !menu.hidden;
      fecharTodos();
      if (aberto) return;
      menu.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    });
    menu.addEventListener('click', function (e) { e.stopPropagation(); });
  }
  function fecharTodos() {
    $$('.pu-pick__menu').forEach(function (m) { m.hidden = true; });
    $$('.pu-pick__btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  /* O seletor de pais prefere a janela do app Orbe quando ele esta na pagina;
     a lista nativa fica como reserva e envia o formulario de localizacao do
     Shopify, que e quem sabe montar o endereco do mercado. */
  function tentarOrbe() {
    try {
      if (window.mdApp && typeof window.mdApp.openModal === 'function') { window.mdApp.openModal(); return true; }
      var gatilho = D.querySelector('[data-orbe-open], .orbe-selector-trigger, #orbe-selector');
      if (gatilho) { gatilho.click(); return true; }
    } catch (e) { /* segue para a lista nativa */ }
    return false;
  }

  /* ---------- faixa de divergencia de mercado ----------------------------- */
  /* O sinal vem da regiao declarada no idioma do navegador e, na falta dela,
     do fuso horario. SEM SINAL, NAO APARECE: o erro cai para o lado de nao
     incomodar. So aparece na divergencia — nunca um pop-up em todo acesso. */
  var TZ2CC = {
    'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US', 'America/Los_Angeles': 'US',
    'America/Toronto': 'CA', 'America/Vancouver': 'CA', 'Europe/London': 'GB', 'Europe/Dublin': 'IE',
    'Europe/Lisbon': 'PT', 'Europe/Madrid': 'ES', 'Europe/Paris': 'FR', 'Europe/Berlin': 'DE',
    'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE', 'Europe/Zurich': 'CH',
    'Europe/Vienna': 'AT', 'Europe/Stockholm': 'SE', 'Europe/Oslo': 'NO', 'Europe/Copenhagen': 'DK',
    'Asia/Tokyo': 'JP', 'Asia/Seoul': 'KR', 'Asia/Dubai': 'AE', 'Asia/Riyadh': 'SA', 'Asia/Jerusalem': 'IL',
    'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Pacific/Auckland': 'NZ', 'America/Mexico_City': 'MX'
  };
  function paisDoNavegador() {
    var langs = navigator.languages || [navigator.language];
    for (var i = 0; i < langs.length; i++) {
      var m = /[-_]([A-Za-z]{2})$/.exec(langs[i] || '');
      if (m) return m[1].toUpperCase();
    }
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (tz && TZ2CC[tz]) return TZ2CC[tz];
    } catch (e) { /* sem sinal */ }
    return null;
  }
  function marketHint() {
    var barra = $('[data-pu-hint]');
    if (!barra) return;
    try { if (sessionStorage.getItem('pu-hint-off') === '1') return; } catch (e) { /* segue */ }
    var atual = (CFG.country || '').toUpperCase();
    var sinal = paisDoNavegador();
    if (!sinal || !atual || sinal === atual) return;

    var form = $('#pu-country-form');
    var alvo = form ? $('button[value="' + sinal + '"]', form) : null;
    if (!alvo) return; /* a loja nao vende para esse pais: nao oferece nada */

    var nome = $('span', alvo);
    var nomeEl = $('[data-pu-hint-name]', barra);
    if (nomeEl) nomeEl.textContent = nome ? nome.textContent : sinal;
    var ir = $('[data-pu-hint-go]', barra);
    if (ir) ir.addEventListener('click', function (e) { e.preventDefault(); alvo.click(); });
    var x = $('[data-pu-hint-x]', barra);
    if (x) x.addEventListener('click', function () {
      barra.classList.remove('is-on');
      try { sessionStorage.setItem('pu-hint-off', '1'); } catch (e) { /* sem storage, some so nesta visita */ }
    });
    barra.classList.add('is-on');
  }

  /* ---------- ligacao ----------------------------------------------------- */
  function init() {
    paint();
    $$('[data-pu-grid]').forEach(function (g) {
      g.setAttribute('aria-busy', 'true');
      if (!g.textContent.trim()) g.innerHTML = '<p class="pu-nota">' + esc(t('loading')) + '</p>';
    });

    cartEl = $('[data-pu-cart]');
    veilEl = $('[data-pu-cart-veil]');
    bodyEl = $('[data-pu-cart-body]');
    footEl = $('[data-pu-cart-foot]');
    totalEl = $('[data-pu-cart-total]');
    countEl = $('[data-pu-count]');
    qdEl = $('[data-pu-cart-qd]');
    shipEl = $('[data-pu-cart-ship]');
    pdpOvl = $('[data-pu-pdp-ovl]');
    pdpBox = $('[data-pu-pdp]');

    renderGrids();
    bindPicker($('[data-pu-lang]'));
    bindPicker($('[data-pu-country]'));

    var btnPais = $('[data-pu-country] .pu-pick__btn');
    if (btnPais) {
      btnPais.addEventListener('click', function (e) {
        if (tentarOrbe()) { e.stopImmediatePropagation(); fecharTodos(); }
      }, true);
    }

    D.addEventListener('click', fecharTodos);

    /* clique global: a ordem importa. O botao de comprar e tratado ANTES do
       card, porque o card inteiro tambem responde ao clique. */
    D.addEventListener('click', function (e) {
      /* Antes dos botoes de compra: o seletor de quantidade vive dentro da
         ficha, e o +/- nao pode cair no clique do card nem no do carrinho. */
      var passo = e.target.closest('[data-pu-pdp-step]');
      if (passo) {
        e.preventDefault(); e.stopPropagation();
        porQtdPDP(pdpQtd() + Number(passo.dataset.puPdpStep));
        return;
      }

      /* Na ficha a quantidade vem do seletor; no card da vitrine e sempre 1. */
      var add = e.target.closest('[data-pu-add]');
      if (add) {
        e.preventDefault(); e.stopPropagation();
        addToCart(add.dataset.puAdd, false, add, add.closest('.pu-pdp') ? pdpQtd() : 1);
        return;
      }

      var buy = e.target.closest('[data-pu-buy]');
      if (buy) {
        e.preventDefault(); e.stopPropagation();
        addToCart(buy.dataset.puBuy, true, buy, buy.closest('.pu-pdp') ? pdpQtd() : 1);
        return;
      }

      var card = e.target.closest('.pu-card');
      if (card && card.dataset.puHandle) { openPDP(card.dataset.puHandle); return; }

      var abre = e.target.closest('[data-pu-open-handle]');
      if (abre) { openPDP(abre.dataset.puOpenHandle); return; }

      if (e.target.closest('[data-pu-cart-open]')) { openCart(); return; }
      if (e.target.closest('[data-pu-cart-close]')) { closeCart(); return; }
      if (e.target.closest('[data-pu-cart-veil]')) { closeCart(); return; }
      if (e.target.closest('[data-pu-pdp-close]')) { closePDP(); return; }
      if (e.target === pdpOvl) { closePDP(); return; }

      var th = e.target.closest('[data-pu-th]');
      if (th) {
        var i = Number(th.dataset.puTh);
        var handle = null;
        var titulo = $('#pu-pdp-t');
        PRODUCTS.forEach(function (p) { if (titulo && p.t === titulo.textContent) handle = p.h; });
        var prod = PRODUCTS.filter(function (p) { return p.h === handle; })[0];
        var main = $('[data-pu-main]');
        if (prod && main && prod.img[i]) {
          main.src = prod.img[i].s;
          main.alt = prod.img[i].a || prod.t;
          $$('[data-pu-th]').forEach(function (b) { b.removeAttribute('aria-current'); });
          th.setAttribute('aria-current', 'true');
        }
        return;
      }

      var qty = e.target.closest('[data-pu-qty]');
      if (qty) {
        var linha = qty.closest('.pu-line');
        var atual = CART.items.filter(function (it) { return it.key === linha.dataset.key; })[0];
        if (atual) changeQty(atual.key, atual.quantity + Number(qty.dataset.puQty));
        return;
      }
      var rm = e.target.closest('[data-pu-rm]');
      if (rm) {
        var l2 = rm.closest('.pu-line');
        if (l2) changeQty(l2.dataset.key, 0);
        return;
      }
    });

    /* teclado: o card e uma div com role=button, entao Enter e Espaco
       precisam ser tratados na mao. */
    D.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closePDP(); closeCart(); fecharTodos(); return; }
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest && e.target.closest('.pu-card');
      if (card && card === e.target && card.dataset.puHandle) {
        e.preventDefault();
        openPDP(card.dataset.puHandle);
      }
    });

    fetchCart().then(marketHint);
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
